import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { BToast } from 'bootstrap-vue'
import fileDownload from 'js-file-download'
import mensagens from '@/util/mensagens'
import util from '@/util'
import arrayUtil from '@/util/arrayUtil'
import { mapState } from 'vuex'

export default {
  name: 'documentos',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    spinnerProcessando,
    'b-toast': BToast
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina']),
    tabelaSemRegistros () {
      return this.listaDocumentos.length === 0
    }
  },

  data: () => {
    return {
      listaDocumentos: [],
      comboCategorias: [{ text: 'Todos', value: null }],
      category: null,
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        },
        carregandoArquivo: {
          status: {}
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      retorno: {
        sucesso: false,
        mensagem: ''
      }
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.obterListaDocumentos()
    this.obterCategorias()
  },

  methods: {
    async obterListaDocumentos () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        let parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina,
          'category': this.category
        }
        const resposta = await this.axios.post('/documentos', parametrosRequisicao)
        this.listaDocumentos = resposta.data.retorno.dados
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
        this.flagsDeControle.carregandoArquivo.status = arrayUtil.inicializarArrayValoresDefault(resposta.data.retorno.paginacao.registrosPorPagina, false)
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    async obterCategorias () {
      try {
        const resposta = await this.axios.get('documentos/listar/categorias')
        this.comboCategorias = resposta.data.retorno.dados
      } catch (e) {
        this.comboCategorias = []
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaDocumentos()
    },

    async baixarDocumento (id, nomeOriginalDoArquivo, indice) {
      this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
      this.definirFlagCarregandoArquivo(true, indice)
      try {
        const resposta = await this.axios.get('/documentos/download/documento/' + id, {
          responseType: 'blob'
        })
        fileDownload(resposta.data, nomeOriginalDoArquivo)
      } catch (error) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaDownloadDocumento)
      }
      this.definirFlagCarregandoArquivo(false, indice)
      this.definirFlagCarregandoDados(false, '')
    },

    definirFlagCarregandoArquivo (status, indice) {
      this.flagsDeControle.carregandoArquivo.status[indice] = status
    },

    buscarRegistros () {
      this.componentePaginacao.pagina = 1
      this.obterListaDocumentos()
    }
  }
}
